export const teamTableConf = [
  {
    isSortable: true,
    field: 'firstName',
    title: 'Member'
  },
  {
    isSortable: false,
    field: 'userid',
    title: 'User ID'
  },
  {
    isSortable: true,
    field: 'role',
    title: 'Role'
  },
  {
    isSortable: true,
    field: 'groups',
    title: 'Groups'
  },
  {
    isSortable: true,
    field: 'devices',
    title: 'Devices'
  },
  {
    isSortable: true,
    field: 'idp',
    title: 'IdP'
  },
  {
    isSortable: true,
    field: 'lastVpnLogin',
    title: 'Last Agent Login'
  },
  {
    isSortable: true,
    field: 'lastAppLogin',
    title: 'Last Platform Login'
  },
  {
    isSortable: false,
    field: 'activities',
    title: ''
  }
];

export const deviceTableConf = [
  {
    field: 'os',
    title: 'OS'
  },
  {
    field: 'deviceType',
    title: 'Device Type'
  },
  {
    field: 'appVersion',
    title: 'App Version'
  },
  {
    field: 'hostname',
    title: 'Host Name'
  },
  {
    field: 'localeIdentifier',
    title: 'Local Identifier'
  },
  {
    field: 'timezone',
    title: 'Timezone'
  },
  {
    field: 'lastDeviceLogin',
    title: 'Last Agent Login'
  }
];

export const exportConfigTeam = {
  exportUrl: '/customer/platform/team/export',
  exportName: '',
  exportFormat: 'zip'
};

export const accessToExecutiveReport = ['Admin', 'Manager'];
